import { render, staticRenderFns } from "./TextPage.vue?vue&type=template&id=01c78aa0&scoped=true"
import script from "./TextPage.vue?vue&type=script&lang=js"
export * from "./TextPage.vue?vue&type=script&lang=js"
import style0 from "./TextPage.vue?vue&type=style&index=0&id=01c78aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c78aa0",
  null
  
)

export default component.exports